/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 14.05.17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import t from '../../trans';

import PasswordForm from "./PasswordForm";
import Tabs from "../../components/Bootstrap/Tabs";
import {NotificationActions} from "../../services/Notification";

const propTypes = {
    /**
     * Initial dialog:
     *  password - show password form
     *  authcode - show two-factor authenticator code form
     *  forgot - show forgot password form
     */
    dialog: PropTypes.string,
    /**
     * If true - show form on disabled state
     */
    inProgress: PropTypes.bool,
    /**
     * If true, then field for new password will be also displayed
     */
    changePassword: PropTypes.bool,
    /**
     * Default value for e-mail address field
     */
    email: PropTypes.string,
    /**
     * Make email field read-only and also locks authentication dialog to currently selected
     */
    lockEmail: PropTypes.bool,
    /**
     * Callback function called when the user clicks to "Login" button.
     * Signature:
     *      onLogin(type, email, password, authCode [, newPassword])
     */
    onLogin: PropTypes.func,
    /**
     * Callback function called whern the user clicks to "Create new password" button in forgot page.
     * Signature:
     *      onForgot(email)
     * If this prop is missing then "Forgot" link will not be displayed
     */
    onForgot: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Cancel" button.
     * Signature:
     *      onCancel();
     * If missing then "Cancel" button will not be displayed.
     */
    onCancel: PropTypes.func
};

const defaultProps = {
    dialog: "password",
    inProgress: false,
    changePassword: false,
    lockEmail: false
};

class PasswordContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            /**
             * Possible values:
             *  - "password" - show password form
             *  - "authcode" - show authentication code form
             *  - "forgot" - show forgot password form
             */
            dialog: props.dialog,
            authType: props.dialog,
            email: props.email,
            password: "",
            code: "",
            newPassword: "",
            newPassword2: ""
        };

        this.onChange = this.onChange.bind(this);
        this.onSelectTab = this.onSelectTab.bind(this);
        this.onSelectPassword = this.onSelectPassword.bind(this);
        this.onSelectAuthcode = this.onSelectAuthcode.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            dialog: nextProps.dialog,
            email: nextProps.email
        });
    }

    render() {
        if (this.state.dialog === "forgot") return this.renderForgot();
        if (this.props.lockEmail) return this.renderPassword(this.state.authType === "authcode");
        return (
            <Tabs selected={this.state.dialog} onSelectTab={this.onSelectTab}>
                <div id="password" title={t("Password")}>{this.renderPassword(false)}</div>
                <div id="authcode" title={t("Two-Step")}>{this.renderPassword(true)}</div>
            </Tabs>
        );
    }

    renderPassword(askCode) {
        return (
            <PasswordForm
                askCode={askCode}
                disabled={this.props.inProgress}
                email={this.state.email}
                password={this.state.password}
                changePassword={this.props.changePassword}
                code={this.state.code}
                lockEmail={this.props.lockEmail}
                onChange={this.onChange}
                onSubmit={this.onLogin}
                onForgotPassword={this.props.onForgot}
                onCancel={this.props.onCancel}/>
        );
    }

    renderForgot() {
        // TODO: Realiseerida forgot password vorm
        return null;
    }

    onChange(field, value) {
        this.setState({[field]: value});
    }

    onSelectTab(tab) {
        this.setState({dialog: tab});
    }

    onSelectPassword() {
        this.setState({dialog: "password"});
    }

    onSelectAuthcode() {
        this.setState({dialog: "authcode"});
    }

    onLogin(email, password, code) {
        if (this.props.changePassword) {
            if (this.state.newPassword !== this.state.newPassword2) {
                NotificationActions.error(t("New password does not match"));
                return;
            }
        }
        if (this.props.onLogin)
            this.props.onLogin(
                this.state.dialog,
                this.state.email,
                this.state.password,
                (this.state.dialog === "authcode" ? this.state.code : null),
                this.state.newPassword);
    }
}

PasswordContainer.propTypes = propTypes;
PasswordContainer.defaultProps = defaultProps;

export default PasswordContainer;
